import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import {dataManager} from "../../../Broadtask";
import {useNavigate} from "react-router-dom";
import {RefreshOutlined} from "@mui/icons-material";
import NetworkTaskableCard from "./NetworkTaskableCard";
import GridViewIcon from "@mui/icons-material/GridView";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {buttonStyle, sectionStack} from "../../../../AppStyles";

const NetworkTaskablesPane = (props) => {

    const navigate = useNavigate();

    const [taskables, setTaskables] = useState(null);

    useEffect(() => {
        reload(false);
    }, [props.networkUID]);

    function reload(force)
    {
        dataManager.getNetworkManager().getInstance(props.networkUID).getTaskables(force, (taskables) => {
            setTaskables(taskables);
        });
    }

    function onRefresh()
    {
        reload(true);
    }

    function onAdd()
    {
        navigate("/networks/" + props.networkUID + "/taskables/add");
    }

    function onView()
    {
        navigate("/networks/" + props.networkUID + "/taskables");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/network_taskable_assignment.png" width={32} height={32}/>
                    <Typography variant="h6">Assigned Taskables</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onRefresh} title="Refresh"
                            sx={buttonStyle}
                            startIcon={<RefreshOutlined />}>REFRESH</Button>
                    <Button onClick={onAdd}
                            sx={buttonStyle}
                            startIcon={<AddCircleOutlineIcon />}>ADD</Button>
                    <Button onClick={onView}
                            sx={buttonStyle}
                            startIcon={<GridViewIcon />}>VIEW</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="column" spacing={1} padding={1} width="100%" minHeight={100}
                   sx={{ backgroundColor: '#2A333A'}}>
                {
                    taskables === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        taskables.map(nextTaskable => {
                            return (<NetworkTaskableCard key={"taskable_" + nextTaskable.taskableUID} networkUID={props.networkUID} entry={nextTaskable} />)
                        })
                }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
    );
}

export default NetworkTaskablesPane;
